import { render } from "./SidenavBlock.vue?vue&type=template&id=f24701ac"
import script from "./SidenavBlock.vue?vue&type=script&lang=js"
export * from "./SidenavBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__